export const EyeClosed = ({ size = 20, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.5 2.5L17.5 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.8207 8.82227C8.16947 9.47304 8.16909 10.5285 8.81987 11.1798C9.47064 11.831 10.5261 11.8314 11.1774 11.1806"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.59756 3.74964C7.19932 3.86357 6.96883 4.27876 7.08276 4.67699C7.19668 5.07523 7.61187 5.30572 8.01011 5.1918L7.80383 4.47072L7.59756 3.74964ZM10.0013 4.16655L9.99868 4.91655H10.0013V4.16655ZM18.3347 9.99989L18.9858 10.3721C19.1176 10.1415 19.1176 9.85838 18.9858 9.62777L18.3347 9.99989ZM15.6981 12.3975C15.4169 12.7017 15.4356 13.1762 15.7398 13.4573C16.044 13.7385 16.5185 13.7198 16.7996 13.4156L16.2488 12.9066L15.6981 12.3975ZM14.8848 15.0792C15.2282 14.8476 15.3189 14.3814 15.0873 14.038C14.8557 13.6946 14.3895 13.604 14.0461 13.8356L14.4655 14.4574L14.8848 15.0792ZM1.66797 9.99989L1.01684 9.62769C0.885028 9.85829 0.885012 10.1414 1.0168 10.372L1.66797 9.99989ZM5.94898 6.16974C6.29177 5.93722 6.38117 5.47084 6.14865 5.12804C5.91614 4.78525 5.44975 4.69585 5.10696 4.92837L5.52797 5.54905L5.94898 6.16974ZM7.80383 4.47072L8.01011 5.1918C8.65669 5.00683 9.32616 4.91417 9.99868 4.91655L10.0013 4.16655L10.004 3.41656C9.19016 3.41367 8.38001 3.52581 7.59756 3.74964L7.80383 4.47072ZM10.0013 4.16655V4.91655C12.9747 4.91655 15.5423 6.62515 17.6835 10.372L18.3347 9.99989L18.9858 9.62777C16.682 5.59629 13.6947 3.41655 10.0013 3.41655V4.16655ZM18.3347 9.99989L17.6835 9.62768C17.058 10.722 16.3953 11.6431 15.6981 12.3975L16.2488 12.9066L16.7996 13.4156C17.5874 12.5633 18.3147 11.5461 18.9858 10.3721L18.3347 9.99989ZM14.4655 14.4574L14.0461 13.8356C12.8087 14.6701 11.4677 15.0832 10.0013 15.0832V15.8332V16.5832C11.7716 16.5832 13.4039 16.078 14.8848 15.0792L14.4655 14.4574ZM10.0013 15.8332V15.0832C7.02798 15.0832 4.46032 13.3746 2.31914 9.62777L1.66797 9.99989L1.0168 10.372C3.32062 14.4035 6.30796 16.5832 10.0013 16.5832V15.8332ZM1.66797 9.99989L2.3191 10.3721C3.42094 8.44446 4.63686 7.05975 5.94898 6.16974L5.52797 5.54905L5.10696 4.92837C3.55408 5.98169 2.19667 7.56364 1.01684 9.62769L1.66797 9.99989Z"
        fill="currentColor"
      />
    </svg>
  );
};
